import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TermpageService } from '../usLegalPage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-us-legal-support',
  templateUrl: './us-legal-support.component.html',
  styleUrls: ['./us-legal-support.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class UsLegalSupportComponent implements OnInit, OnDestroy {
  @Input() pageData:any;
  queryParams: any;
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  termData: any;

  constructor(
    private termpageService: TermpageService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnInit(): void {
    if (this.pageData != null) {
      this.termData = {
        header: this.pageData.actionPanel.fields.title,
        button: {
          text: this.pageData.actionPanel.fields.button[0].fields.buttonText,
          url: this.pageData.actionPanel.fields.button[0].fields.redirectLink,
          target: this.pageData.actionPanel.fields.button[0].fields.actionType,
        },
      };
    }
  }
}
